import { DefaultProps } from 'typings'
import styles from './fieldDetails.css'
import { Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import messages from './messages'

export function FieldDetails(props: DefaultProps) {
  return <span className={styles.container}>{props.children}</span>
}

function Line(props: DefaultProps) {
  return <div className={styles.line}>{props.children}</div>
}

interface FieldTextProps {
  text?: string
}

function Error(props: FieldTextProps) {
  const { text } = props

  return (
    <Text variant="detail" tone="critical" className={styles.text}>
      {text}
    </Text>
  )
}

function Help(props: FieldTextProps) {
  const { text } = props

  return (
    <Text variant="detail" tone="secondary" className={styles.text}>
      {text}
    </Text>
  )
}

interface FieldTextCounter {
  count?: number
  max?: number
}

function Counter(props: FieldTextCounter) {
  const { count, max } = props
  const { formatMessage: i18n } = useIntl()

  const shouldBeHidden = max === undefined || count === undefined

  if (shouldBeHidden) {
    return null
  }

  return (
    <Text variant="detail" tone="secondary" className={styles.counter}>
      {i18n(messages.counter, {
        count: count,
        max: max,
      })}
    </Text>
  )
}

FieldDetails.Error = Error
FieldDetails.Help = Help
FieldDetails.Counter = Counter
FieldDetails.Line = Line
